import styled from 'styled-components'
import pxToRem from '../utils/pxToRem'
import { deviceMax } from '../theme/breakpoints'
import IconButton from '../components/IconButton/IconButton'
import Heading from '../components/Heading/Heading'
import { MainContainer } from '../theme/mainContainer.styled'
import Chip from '../components/Chip/Chip'
import CardContact from '../components/CardContact/CardContact'
import Carousel from '../components/Carousel/Carousel'
import Slider from '../components/Slider/Slider'

export const StyledStoryContent = styled.div`
  grid-area: content;
  border-radius: ${pxToRem(5)};
  padding: ${pxToRem(20)};
  width: 100%;
  height: fit-content;
  background-color: ${({ theme }) => theme.colors.unique.white};

  @media ${deviceMax.tablet} {
    min-width: auto;
    border-radius: initial;
  }
`

export const StyledStoryInfos = styled.div`
  justify-content: space-between;
  display: flex;
  margin-bottom: ${pxToRem(20)};
  @media ${deviceMax.mobileL} {
    flex-direction: column;
  }
`

export const StyledStoryDateCategories = styled.div`
  display: flex;
  flex-direction: row;
  @media ${deviceMax.mobileL} {
    justify-content: space-between;
    margin-bottom: ${pxToRem(10)};
  }
`

export const StyledStoryDate = styled.div`
  align-items: center;
  display: flex;
`

export const StyledStoryCategories = styled.div`
  align-items: center;
  display: flex;
  @media ${deviceMax.mobileL} {
    flex-wrap: wrap;
    gap: ${pxToRem(10)};
  }
`

export const StyledDecoration = styled.div`
  margin-right: ${({ $color }) => ($color === 'lime' ? `${pxToRem(10)}` : '0')};
  margin-left: ${({ $color }) => ($color === 'blue' ? `${pxToRem(10)}` : '0')};
  width: ${pxToRem(20)};
  height: ${pxToRem(2)};
  background-color: ${({ theme, $color }) =>
    $color === 'lime'
      ? theme.colors.custom.lime
      : theme.colors.custom.blueLight};
  @media ${deviceMax.mobileL} {
    display: ${({ $color }) => ($color === 'lime' ? 'flex' : 'none')};
  }
`

export const StyledDate = styled.span`
  font-size: ${({ theme }) => theme.fonts.sizes.button};
  font-weight: ${({ theme }) => theme.fonts.weight.semibold};
  line-height: ${({ theme }) => theme.fonts.lineHeight.button};
  @media ${deviceMax.mobileL} {
    font-size: ${({ theme }) => theme.fonts.sizes.base};
    font-weight: ${({ theme }) => theme.fonts.weight.semibold};
    line-height: ${({ theme }) => theme.fonts.lineHeight.button};
  }
`

/* -------------------------------------------------- */
export const StyledIconsContainer = styled.div`
  justify-content: space-between;
  align-items: center;
  display: flex;
  @media ${deviceMax.mobileL} {
    align-items: baseline;
  }
`

export const StyledIcon = styled(IconButton)`
  justify-content: center;
  align-items: center;
  display: flex;
  border: ${pxToRem(1)} solid ${({ theme }) => theme.colors.unique.black};
  border-radius: ${pxToRem(5)};
  padding: ${pxToRem(3)};
  width: ${pxToRem(30)};
  height: ${pxToRem(30)};
  margin-left: ${pxToRem(20)};

  & svg {
    height: ${pxToRem(24)};
  }
`

export const StyledShareIcon = styled(StyledIcon)`
  & svg {
    padding: 0;
  }
`
export const StyledHeading = styled(Heading)`
  margin-bottom: ${pxToRem(20)};
`

export const StyledStoryElements = styled.div`
  flex-direction: column;
  display: flex;
  margin-left: ${pxToRem(20)};
  min-width: ${pxToRem(385)};
  @media ${deviceMax.tablet} {
    margin: 0;
  }
  @media ${deviceMax.mobileM} {
    min-width: initial;
    max-width: 100%;
  }
`

export const StyledStoryContainer = styled(MainContainer)`
  gap: ${pxToRem(20)};
  flex-direction: column;
  align-items: center;
  display: flex;
  max-width: ${pxToRem(800)};
  margin-bottom: ${pxToRem(40)};

  @media ${deviceMax.tablet} {
    flex-direction: column;
    max-width: initial;
    width: 100%;
    margin: 0;
  }
`
export const StyledChip = styled(Chip)`
  position: initial;
  border-radius: ${pxToRem(40)};
  background-color: ${({ theme }) => theme.colors.opacity.white20};
  border: ${pxToRem(1)} solid ${({ theme }) => theme.colors.unique.black};
  padding: ${pxToRem(1)} ${pxToRem(1)};
  margin: ${pxToRem(0)} ${pxToRem(10)};
  @media ${deviceMax.mobileL} {
    margin: 0;
  }
`

export const StyledSeparator = styled.div`
  margin-bottom: ${pxToRem(20)};
  height: ${pxToRem(1)};
  background-color: ${({ theme }) => theme.colors.secondary.grey95};
`

export const StyleDocumentCarousel = styled(Carousel)`
  margin: initial;
  padding: initial;
  background-color: transparent;
  @media ${deviceMax.mobileM} {
    padding: 0 ${pxToRem(20)};
  }
`

export const StyledVideo = styled.div`
  width: 100%;
  video {
    width: 100%;
    height: 100%;
    border-radius: ${pxToRem(5)};
  }
  @media ${deviceMax.mobileL} {
    video {
      border-radius: initial;
    }
  }
`

export const StyledSlider = styled(Slider)`
  max-width: initial;
`

export const MOBILE_TITLE = 'Story'
